const  NonMass=[
    
  {
    id: 1,
    title: 'Mirage 350мл',
    isNew: true,
    price: '95 грн',
    src: require('../img/Mirage.png'),
    text: `сироп карамель,
сироп корица,
сироп малина,
сок лимон,
сок вишня,
7ап`,
  }, 
  {
    id: 2,
    title: 'Sour Me 250мл',
    isNew: true,
    price: '90 грн',
    src: require('../img/SourMe.png'),
    text: `ciк лимона,
сiк ананас, 
сироп маракуя,
7ап`,
  },
  
  {
    id: 3,
    title: 'apple snap 250мл',
    isNew: true,
    price: '100 грн',
    src: require('../img/applesnap.png'),
    text: `cироп яблоко,
сок лимон,
тоник,
Вода з огірком`,
  },
    {
        id:4,
        title:"Перфекціоніст 350мл",
        price:"90 грн",
        src: require('../img/perfect.png'),
        text:"сироп ківі, ананасовий сік, лайм, тонік",
    },
    {
        id:5,
        title:"Перлинна 350мл",
        price:"90 грн",
        src: require('../img/perlina.png'),
        text:"яблучний сік, ананасовий сік, ванільний сироп, 7up",
    },
    {
        id:6,
        title:"фіат 250мл",
        price:"110 грн",
        src: require('../img/fiat.png'),
        text:"сироп кокос, вишневий сік, сироп гренадін, лаймовий сік, м'ята",
    },
    // {
    //     id:7,
    //     title:"aperol sour AF 250мл",
    //     price:"100 грн",
    //     src: require('../img/apersour.png'),
    //     text:"сироп бузина, сироп апероль, апельсиновий сік, лимонний сік, , ізі фом",
    // },
    // {
    //     id:8,
    //     title:"Фрізі ківі 450мл",
    //     price:"120 грн",
    //     src: require('../img/kivi.webp'),
    //     text:"сироп ківі, м’ята, лайм, тонік",
    // },
    {
        id:9,
        title:"Блакитна Лагуна 350мл",
        price:"110 грн",
        src: require('../img/lagu.webp'),
        text:"сироп блю кюрасао, 7up, фреш лимону",
    },
    {
        id:10,
        title:"Твереза Коллада 350мл",
        price:"130 грн",
        src: require('../img/colada.webp'),
        text:"сироп кокосовий, сік ананасовий, вершки, пюре ананас",
    },
    {
        id:11,
        title:"Кавунові часточки 350мл",
        price:"110 грн",
        src: require('../img/arb.webp'),
        text:"сироп кавуновий, 7up, лайм",
    },
    {
        id:12,
        title:"Персикова долина 350мл",
        price:"110 грн",
        src: require('../img/dol.webp'),
        text:"сироп кокосовий, сироп персиковий, сік ананасовий, вершки",
    },
    {
        id:13,
        title:"Мілк шейк 350мл",
        price:"90 грн",
        src: require('../img/shak.webp'),
        text:"в асортименті",
    },
    // {
    //     id:14,
    //     title:"Мілк шейк полуниця банан 350мл",
    //     price:"90 грн",
    //     src: require('../img/polunbanan.png'),
    //     text:"сироп полуниці, банан, молоко, морозиво",
    // },
    {
        id:15,
        title:"Мілк шейк орео 350мл",
        price:"100 грн",
        src: require('../img/oreo.png'),
        text:"сироп ванільний, печиво орео, молоко, морозиво",
    },
    {
        id:16,
        title:"Мілк шейк ванільно карамельний 350мл",
        price:"90 грн",
        src: require('../img/vankaramel.png'),
        text:"сироп ванільний, сироп карамель, молоко, морозиво",
    },
    {
        id:17,
        title:"Джин-тонік б/а 250мл",
        price:"160 грн",
        src: require('../img/ton.webp'),
        text:"джин 0.0, тонік, лимон",
    },
    {
        id:18,
        title:"Апероль спрітц 350мл",
        price:"110 грн",
        src: require('../img/aper.webp'),
        text:"Сироп Апероль, Сік апельсину, Тонік, Сироп бузина",
    },
//     {
//         id:18,
//         title:"Б/а глінтвейн 300мл",
//         price:"99 грн",
//         src: require('../img/glintChervoniy.png'),
//         isHot: true,
//         text:`Сік вишня, 
// Сироп кориця,
// Спеції,
// Лимон,
// Апельсин`,
//     },
]

export default NonMass;